__turbopack_context__.v({
  "activeTabIndicator": "staticTemplateTabs-module-scss-module__g88Viq__activeTabIndicator",
  "activeTabLink": "staticTemplateTabs-module-scss-module__g88Viq__activeTabLink",
  "selectTabs": "staticTemplateTabs-module-scss-module__g88Viq__selectTabs",
  "stickyTabsWrapper": "staticTemplateTabs-module-scss-module__g88Viq__stickyTabsWrapper",
  "stickyTabsWrapperFixed": "staticTemplateTabs-module-scss-module__g88Viq__stickyTabsWrapperFixed",
  "tab": "staticTemplateTabs-module-scss-module__g88Viq__tab",
  "tabsRow": "staticTemplateTabs-module-scss-module__g88Viq__tabsRow",
});
